const AUTH_USER_KEY = '@cillar/auth-token';

export {AUTH_USER_KEY};
